import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { invalidateAutomationTemplateQuery } from '../../queries/useAutomationTemplateQuery';

interface Params {
	templateId: string;
	stepId: string;
	attachmentFiles: File[];
	impersonationContext?: Api.IImpersonationContext;
}

export function useAddTextingStepAttachmentsMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ITextingAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ templateId, stepId, attachmentFiles, impersonationContext }: Params) => {
			const formData = new FormData();
			for (const file of attachmentFiles) {
				formData.append('files', file);
			}
			return userSession.webServiceHelper.callAsync<Api.ITextingAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Texting/${encodeURIComponent(
						stepId
					)}/Attachment`,
					impersonationContext,
				}),
				'POST',
				formData
			);
		},
		onError,
		onSuccess: (data, variables) => {
			invalidateAutomationTemplateQuery(variables.templateId);
			onSuccess?.(data, variables);
		},
	});
}
